<template>
  <div>
    <hhead></hhead>
    <nnav></nnav>
    <iframe
      src="/static/pages/html/home.html"
      frameborder="0"
      class="iframe"
      :style="{ width: '100%', height: heit, display: 'block' }"
    ></iframe>
  </div>
</template>
<script>
import hhead from '../../../../components/header/index';
import nnav from '../../../../components/nav/index';
import './style.css';
export default {
  name: 'vview',
  components: { hhead, nnav },
  data() {
    return {
      heit: window.innerHeight - 54 + 'px',
    };
  },
  mounted() {},
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/view/user/ctp_user/view/index.vue